module.exports = __webpack_public_path__ + "img/ace.bae871c0.png";